import React, { Fragment } from 'react';
import { View } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { Caption1, Text } from 'src/components/Typography';
import { Link } from './Link';

storiesOf('Link', module).add('Default', () => (
  <Fragment>
    <PanelHeader>🔗 Link</PanelHeader>
    <PlatformPadding vertical horizontal>
      <View>
        <Text>
          <Link>example.com</Link>
        </Text>
      </View>
    </PlatformPadding>
    <PlatformPadding vertical horizontal>
      <View>
        <Text>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cum ex{' '}
          <Link>facere iusto magnam</Link> officia, praesentium quidem quisquam repellendus.{' '}
          <Link>Aperiam, quam</Link>.
        </Text>
      </View>
    </PlatformPadding>
    <PlatformPadding vertical horizontal>
      <View>
        <Caption1>
          Регистрируясь, вы соглашаетесь с <Link href="https://google.com">Условиями</Link> и{' '}
          <Link href="https://google.com">Политикой конфиденциальности</Link>.
        </Caption1>
      </View>
    </PlatformPadding>
  </Fragment>
));
